import { render, staticRenderFns } from "./DisplayFormatSelector.vue?vue&type=template&id=3fccb8ef&lang=pug&"
import script from "./DisplayFormatSelector.vue?vue&type=script&lang=ts&"
export * from "./DisplayFormatSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports